var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-td",style:({
			'min-width': _vm.width + 'px',
			'border-left-width': _vm.borderType === 'grid' ? '1px' : '0',
			'border-bottom-width': _vm.borderType === 'none' ? '0' : '1px',
			'border-color' : _vm.borderColor,
			'justify-content': _vm.tdAlignCpd
		})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }